// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"BlockedOrgPage-primaryButton-3MocDn","container":"BlockedOrgPage-container-1WL6ll","title":"BlockedOrgPage-title-3nriQb","text":"BlockedOrgPage-text-1-cK2m"};